import { graphql, useMutation } from "react-relay";
import { useRegisterSessionMutation } from "./__generated__/useRegisterSessionMutation.graphql";
import { useEffect } from "react";

import { useUser } from "@/src/OS/Login/State";
import { DateTime, Duration } from "luxon";
import { usePrevious } from "../usePrevious";
import { useAppState } from "@/src/utils";

const SESSION_LENGTH = Duration.fromObject({ minutes: 10 });

const sessions = new Map<string, DateTime>();

export function useRegisterSession(isIndividualStoreAccount: boolean) {
  const user = useUser();
  const key = user.user.sub + ":" + user.currentStoreId;

  const [register] = useMutation<useRegisterSessionMutation>(graphql`
    mutation useRegisterSessionMutation {
      storeViewer {
        registerActivity(type: SESSION_STARTED) {
          __typename
        }
      }
    }
  `);

  const appState = useAppState();
  const previousAppState = usePrevious(appState);

  useEffect(() => {
    if (
      (previousAppState === "background" ||
        previousAppState === "inactive" ||
        !previousAppState) &&
      appState === "active"
    ) {
      if (isIndividualStoreAccount) {
        const lastSession = sessions.get(key);
        if (!lastSession || lastSession.plus(SESSION_LENGTH) < DateTime.now()) {
          register({
            variables: {},
          });
          sessions.set(key, DateTime.now());
        }
      }
    }
  }, [appState, isIndividualStoreAccount, key, previousAppState, register]);
}
